module.exports = __webpack_public_path__ + "img/insta-icon.528e4cc5.svg";